export default __webpack_public_path__ + "48d9a3c0b61f1d8a75cc63a073dbb62c.svg";